<template>
  <div>
    <div style="text-align:center;">
      <img src="../../../public/img/logo_entreprise.png" alt="IDEAL SOLUTIONS" style="width:50%;"/>
    </div>
  </div>
</template>

<script>
import script from '../../script/script.js';

export default {
  data() {
    return {
      
    }
  },
  mounted:function(){
    this.verifyRight();
  },
  computed:{
  },
  methods: {
    verifyRight: script.verifyRight
  }
  
}
</script>

<style>

</style>
